export default __webpack_public_path__ + "static/img-data-prep-preview-c0c5580f4d56cbed3dde124474630c06.png";